module.exports = __webpack_public_path__ + "img/dentalPro.74e56987.png";